export default "__VITE_ASSET__b7e71f67__"